export enum TaskLinkTypes {
    None,
    Project,
    Customer,
    Vessel
}

